var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{staticClass:"h-100 no-scroll",attrs:{"type":"border-card"}},_vm._l((_vm.menuList),function(menu,index){return _c('el-tab-pane',{key:index,staticClass:"mt-2",attrs:{"label":menu.name}},[_c(menu.tag,{tag:"component",staticClass:"px-3 pb-2",attrs:{"scrId":_vm.scrId}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }